import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { AppFeatures } from 'components/GrowthBookWrapper/GrowthBookWrapper';
import { ProductPriceDropType } from 'types/product.types';

export const PRICE_DROP_BADGE_FLAG = 'price_drop_badge' as const;

export const usePriceDropBadge = (priceDrop?: ProductPriceDropType | null, hidden = false): ProductPriceDropType | null => {
  const enabled = useFeatureIsOn<AppFeatures>(PRICE_DROP_BADGE_FLAG);

  return enabled && !hidden && priceDrop ? priceDrop : null;
};
